import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../store/actions/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import Arbitrator from './Arbitrator';
import RadioGroup from '@material-ui/core/RadioGroup';
import axios from 'axios';
import PropTypes from 'prop-types';
import Grid from "@material-ui/core/Grid";
import PrimaryAppBarMobile from "../components/PrimaryAppBarMobile";
import withSizes from "react-sizes";

const styles = theme => ({
    formControl: {
        // margin: theme.spacing.unit * 3,
    },
    root: {
        display: 'flex',
        justifyContent: 'center'
      },
    gridList: {
        margin: '0 auto'
      },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
      },
});

class ArbitrationListForView extends Component {
    state = {
      value: null,
      open: false,
      uniqueId: localStorage.getItem('token'),
      windowHeight: undefined,
      windowWidth: undefined
    };

    handleResize = () => {
        this.setState({
          windowHeight: window.innerHeight,
          windowWidth: window.innerWidth
        })
      } 
      
      componentWillMount() {
        window.removeEventListener('resize', this.handleResize)
      }
      
    componentDidMount(){
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
        // let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getCaseInfo`;
        // let payload = {
        //     caseId: this.props.match.params.id,
        // }
        // axios.post(url, payload)
        // .then((response) => {
        //     if(response.data === 'error' || response.data === 'failed'){
        //         throw (`login ${response.data}`);
        //     }
        //     this.setState({value: response.data.claimantArbitrator});

        // })
        // .catch((error) => {
        //     console.log(error);
        // });

        // if (this.props.lang == 'en'){
            this.props.getArbitrators(localStorage.getItem('token'));
        // }
        // else{
        //     this.props.getArbitratorsChi(localStorage.getItem('token'));
        // }
    }

    render(){
        const { classes, isLoading, arbitrators } = this.props;
        var jurisdiction_ = this.context.t('Jurisdiction');
        var occupation_ = this.context.t('Occupation');
        var lang = localStorage.getItem('language');
        console.log('localStorage.getItem(language) arb: '+localStorage.getItem('language'));
        console.log('lang arb: '+lang);
        console.log('jurisdiction_: '+jurisdiction_+' occupation_: '+occupation_)

        if(isLoading){
            return(
                <CircularProgress size={50} thickness={3} className={classes.progress}/>
            );
        }
        else{
            return(
                <div className={classes.root}>
                <Grid
                    container
                    direction="row"
                    justify="space-evenly"
                    alignItems="center"
                    style={{padding:'10px'}}
                    >
                    <RadioGroup row style={{  justifyContent: (this.props.isMobile || this.state.windowWidth < 700) ? 'center':'left'}} >
                    {
                        arbitrators.map( (arbitrator) => (
                            <Arbitrator 
                                firstName={arbitrator.firstname}
                                lastName={arbitrator.lastname}
                                occupation={arbitrator.occupation}
                                jurisdiction={arbitrator.jurisdiction}
                                expertise={arbitrator.expertise}
                                arbitratorId={arbitrator.arbitratorId}
                                firstName_chi={arbitrator.firstname_chi}
                                lastName_chi={arbitrator.lastname_chi}
                                occupation_chi={arbitrator.occupation_chi}
                                jurisdiction_chi={arbitrator.jurisdiction_chi}
                                expertise_chi={arbitrator.expertise_chi}
                                lang = {lang}
                                arbitrator={this.context.t('arbitrator')}
                                arbitratorProfile={this.context.t('arbitratorProfile')}
                                jurisdictions={ this.context.t('Jurisdiction') }
                                occupations={ this.context.t('Occupation') }
                            />
                        ))
                    }
                    </RadioGroup>    
                </Grid>
              
              </div>
            );
        }

        
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.arbitrator.loading,
        arbitrators: state.arbitrator.arbitrators,
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        caseData: state.caseInfo.caseData,
        lang: state.i18nState.lang,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getArbitrators: () => dispatch(actions.arbitrators()),
        getArbitratorsChi: () => dispatch(actions.arbitratorsChi()),
        setArbitrators: (caseId, firstTime, arbitratorId, type, handleComplete) => dispatch(actions.setArbitrators(caseId, firstTime, arbitratorId, type, handleComplete)),
    }
}

const mapSizesToProps = (sizes) => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet: withSizes.isTablet(sizes),
    isDesktop: withSizes.isDesktop(sizes),
    isGtMobile: withSizes.isGtMobile(sizes),
    isGtTablet: withSizes.isGtTablet(sizes),
    isStTablet: withSizes.isStTablet(sizes),
    isStDesktop: withSizes.isStDesktop(sizes),
    isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
  });

ArbitrationListForView.contextTypes = {
    t: PropTypes.func
}

// export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ArbitrationListForView)));
export default connect( mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps)(withStyles(styles)(withRouter(ArbitrationListForView))));
